import {
  facebookMessengerPreviousViewMap,
  scheduledVideoPreviousViewMap,
  whatsappPreviousViewMap,
  callbackPreviousViewMap,
  audioPreviousViewMap,
  videoPreviousViewMap,
  chatPreviousViewMap,
  faqPreviousViewMap,
} from '../widgetManager/utils/backToPreviousViewMaps.js'
import { widgetManager } from '../widgetManager/index.js'

export const handleBackArrow = (singleChannel, callMeActive) => {
  const [, tab = null, view] = widgetManager.getWidgetTab()?.split('.') || []
  switch (tab) {
    case 'callback':
      if (view === 'schedule' && !callMeActive) {
        widgetManager.setWidgetTab('trueengage.channel_picker')
        return
      } else if (view === 'thanks' && !callMeActive) {
        widgetManager.setWidgetTab('trueengage.callback.schedule')
        return
      } else if (view === 'thanks' && callMeActive) {
        widgetManager.setWidgetTab('trueengage.callback')
        return
      }
      widgetManager.setWidgetTab(callbackPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'chat':
      widgetManager.setWidgetTab(chatPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'whatsapp':
      widgetManager.setWidgetTab(whatsappPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'facebookMessenger':
      widgetManager.setWidgetTab(facebookMessengerPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'faq':
      widgetManager.setWidgetTab(faqPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'audio':
      widgetManager.setWidgetTab(audioPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'video':
      widgetManager.setWidgetTab(videoPreviousViewMap[view] || 'trueengage.channel_picker')
      break
    case 'scheduledVideo':
      widgetManager.setWidgetTab(scheduledVideoPreviousViewMap[view] || 'trueengage.channel_picker')
      break
  }
}
